import * as query from "@arcgis/core/rest/query";

let _service; 
let _token; 

export default async function findZoning(geometry, service, zones, token) {
    _token = token ?? null; 
    _service = service; 
    let promises = [];
    let allResults = [];

    for (const [key, value] of Object.entries(zones)) {
        try {
            promises.push(getZoningInfo(geometry, key, value)); 
        } catch (error) {
            console.error("Error occurred while fetching zoning info:", error);
        }
    }
    let resultObjs = await Promise.all(promises); 

    resultObjs.forEach((results) => {
        if (results && results.features.length > 0) {
            results.features.forEach(feature => {
                allResults.push(feature)
            });
        }
    })

    return allResults;
}

function getZoningInfo(geometry, layer, outfields) {
    if (_token){
        return query.executeQueryJSON(`${_service}${layer}`, {
            geometry: geometry,
            outFields: outfields,
        }, {headers: {'RequestVerificationToken': _token }});
    }
    else {
        return query.executeQueryJSON(`${_service}${layer}`, {
            geometry: geometry,
            outFields: outfields,
        });
    }
}